import React, { Fragment } from 'react';
import { CSVLink } from 'react-csv';
import { Button, Row, Col } from 'react-bootstrap';
import '../../../styles/export.scss'

const DataExporter = ({ data, nome }) => {
    const convertToCSV = (data) => {
        const csvData = [];
        const csvHeaders = Object.keys(data[0]);
        csvData.push(csvHeaders.join(','));

        data.forEach(item => {
            const values = csvHeaders.map(header => item[header]);
            csvData.push(values.join(','));
        });

        return csvData.join('\n');
    };

    const exportJSON = (data) => {
        const jsonData = JSON.stringify(data, null, 2);
        const blob = new Blob([jsonData], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${nome}.json`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    const exportTXT = (data) => {
        const txtData = data.map(item => JSON.stringify(item)).join('\n');
        const blob = new Blob([txtData], { type: 'text/plain' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${nome}.txt`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    };

    return (
        <Fragment>
            <Row xs={1} lg={3}>
                <Col>
                    <Button onClick={() => exportJSON(data)} type='button' variant='success'>Exportar JSON</Button>
                </Col>
                <Col>
                    <Button onClick={() => exportTXT(data)} type='button' variant='success'>Exportar TXT</Button>
                </Col>
                <Col>
                    <Button type='button' variant='success'><CSVLink data={data} filename={`${nome}.csv`} type='button' variant='success'>Exportar CSV</CSVLink></Button>
                </Col>
            </Row>
        </Fragment >
    );
};

export default DataExporter;
